import { render } from "./RemarkEditor.vue?vue&type=template&id=07a35469"
import script from "./RemarkEditor.vue?vue&type=script&lang=js"
export * from "./RemarkEditor.vue?vue&type=script&lang=js"

import "./RemarkEditor.vue?vue&type=style&index=0&id=07a35469&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__